import { unlockBodyScroll } from '~/utilities/ui-utilities';

export default defineNuxtRouteMiddleware(() => {
  nextTick(() => {
    unlockBodyScroll();
    setTimeout(() => {
      window?.scrollTo({
        top: 0,
      });
    }, 250);
  });
});
